<template>
    <v-row class="pb-3">
      <v-col cols="12">
        <v-row>
          <v-col cols="2" class="pl-0">
            <div class="redLine pa-0 ma-0"></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12 pa-0 ma-0">
            <v-card flat class="country-name-vcard" max-width="100%">
              <v-row>
                <v-col cols="10">
                  <v-card-title v-auto-resize-text class="countryNameText pa-0 ma-0">
                    {{ countryName }}
                  </v-card-title>
                </v-col>
                <v-col cols="2">
                  <v-btn icon @click="closeModal" variant="text" class="crossButton iconButton_light">
                    <v-icon class="crossIcon" flat :ripple="false">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import store from '@/store';
  
  // Define a custom type that extends HTMLElement
  interface ResizableHTMLElement extends HTMLElement {
    __resizeListener?: () => void;
  }
  
  const autoResizeText = {
    mounted(el: ResizableHTMLElement) {
      const resize = () => {
        const container = el.parentElement;
        if (!container || !container.firstChild) return;        
  
        // Assert that firstChild is an HTMLElement
        const firstChild = container.firstChild as HTMLElement;
        const maxWidth = firstChild.clientWidth;
        let fontSize = 36; // Start with your default font size
        el.style.fontSize = `${fontSize}px`;
        el.style.whiteSpace = 'nowrap';
  
        while (el.scrollWidth > maxWidth && fontSize > 4) {
          fontSize--;
          el.style.fontSize = `${fontSize}px`;
        }
      };
  
      resize();
      window.addEventListener('resize', resize);
      el.__resizeListener = resize;
    },
    unmounted(el: ResizableHTMLElement) {
      if (el.__resizeListener) {
        window.removeEventListener('resize', el.__resizeListener);
      }
    }
  };
  
  export default defineComponent({
    props: {
      countryName: {
        type: String,
        required: true
      }
    },
    methods: {
      closeModal() {
        store.dispatch('stateStoreData/setModalMode', null);
      }
    },
    directives: {
      autoResizeText
    }
  });
  </script>
  
  <style lang="scss" scoped>
  * {
    font-size: 13px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: -2%;
    font-family: 'GCO', sans-serif;
  }
  
  .country-name-vcard {
    background-color: transparent;
  }
  
  .countryNameText {
    font-weight: 400;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: left;
    overflow: hidden;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .redLine {
    background-color: #DC0028;
    height: 2px;
    width: 1.3em;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    display: block;
    text-align: left;
    margin-left: 0.15em;
    margin-right: auto;
  }
  
  .crossButton {
    width: 32px;
    height: 32px;
    float: right;
  }
  
  .crossIcon {
    font-size: 22px;
  }
  
  /* Media Queries */
  @media (min-width: 900px) {
    .crossButton {
      display: none;
    }
  }
  
  @media (max-width: 900px) {
    .redLine {
      display: none;
    }
  }
  </style>